module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6BAMAAAATlVcbAAAAAXNSR0IArs4c6QAAABVQTFRFAAAAIhgUIhgUIhgUIhgUIhgUIhgUsOcJ9QAAAAd0Uk5TAECBlCxiEJ+zqSAAAACISURBVDjLY2DADRyVcMmwCBkZBSZh16SsrCoGpJmwa0qAsNFkGaGaGDBkWYRMGZgTUBQzIdvEhG4UE7JNWGSdETZhkRVE5ozKjjBZUUE4EGJgFkQBwgyJCI4IAyOqrCADJQCfySIEXDUagyNZFn9phr8kJFSKEi6BCZbehEt+grUG4RoHXlsBADzgGaQLGe78AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/win7up.png
// module id = O4Io
// module chunks = 22